import GlobalModal from './GlobalModal';
import styles from './GlobalModal.module.css';

export { styles as globalModalStyles };
export default GlobalModal; 